import { ChangeDetectionStrategy, Component, forwardRef, contentChildren, input, Signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DefaultControlValueAccessor } from '@coin/shared/core/util-helpers';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { TemplateWithValueDirective } from '@coin/shared/core/util-directives';
import { MatTooltipModule } from '@angular/material/tooltip';

@Component({
  selector: 'coin-radio-pill',
  imports: [CommonModule, MatTooltipModule],
  templateUrl: './radio-pill.component.html',
  styleUrl: './radio-pill.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => RadioPillComponent),
      multi: true
    }
  ]
})
export class RadioPillComponent<T = unknown> extends DefaultControlValueAccessor<T> {
  readonly options = contentChildren(TemplateWithValueDirective);
  readonly variant = input<Variant>(VARIANTS[0]);
  readonly disabledExplanation = input<string>();

  public selectOption(value: T): void {
    if (value === this.value) return;

    this.value = value;
    this.onTouch();
  }
}

export const VARIANTS = ['primary', 'secondary'] as const;
export type Variant = (typeof VARIANTS)[number];
